import type { ToastApi } from "@/ds";
import { getErrorMessage, isAPIError } from "@/core/services";
import { updateUserStatus } from "@/modules/users";
import type { User, UserStatus } from "@/modules/users";
import {
  ACTIVATE_SUCCESS_MESSAGE,
  DEACTIVATE_SUCCESS_MESSAGE,
  TOGGLE_STATUS_ERROR_MESSAGE,
  TOGGLE_STATUS_ERRORS,
} from "../users.constants";

interface UseUsersStatusParams {
  readonly toast: ToastApi;
  /** Sucesso: a tela fecha o modal e refaz a consulta. */
  readonly onUpdated: () => void;
  /** Falha em que repetir não adianta (401, 403, 409): a tela fecha o modal e a listagem segue como estava. */
  readonly onDismissed: () => void;
}

/** Model da ativação e da inativação (HU 723): nada é alterado antes da confirmação no modal (RN04). */
export function useUsersStatus({ toast, onUpdated, onDismissed }: UseUsersStatusParams) {
  /** Nunca rejeita: a falha de gravação mantém o modal aberto para nova tentativa. */
  return async (user: User): Promise<void> => {
    const next: UserStatus = user.status === "ativo" ? "inativo" : "ativo";

    try {
      await updateUserStatus({ id: user.id, status: next });
    } catch (error) {
      const known = isAPIError(error) ? TOGGLE_STATUS_ERRORS[error.status] : undefined;
      if (known) onDismissed();

      toast.error(
        known?.summary ?? TOGGLE_STATUS_ERROR_MESSAGE,
        known?.detail ?? getErrorMessage(error),
      );
      return;
    }

    onUpdated();
    toast.success(
      "Sucesso",
      next === "ativo" ? ACTIVATE_SUCCESS_MESSAGE : DEACTIVATE_SUCCESS_MESSAGE,
    );
  };
}
